import { Numerator } from "../numerator/numerator.model";
import { Employee } from "../company/employees/employee.model";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { ObjectState } from "../configuration/object-states/object-states.model";
import { AttachmentHolder, AttachmentInfo } from "../core/shared/attachments/attachments.model";

export class ProjectListRow {
    id: number;
    numberString: string;
    foreignNumber: string;
    customerId: number;
    customerCode: string;
    customerName: boolean;
    receiverId: number;
    receiverCode: string;
    projectManagerId: number;
    projectManager: string;
    startDate: Date;
    endDate: Date;
    objectStateId: number;
    stateInternalName: string;
    shortDescription: string;
    stateTranslation: string;
}


export class Project implements Numerator, AttachmentHolder {
    numeratorType: string;
    year: number;
    serie: string;
    number: string;
    objectTypeId: number;
    isNew: boolean;
    isNumeratorReadOnly: boolean;
    isNumberReadOnly: boolean;
    id: number;
    numberString: string;
    foreignNumber: string;
    departmentId: number;
    customerId: number;
    receiverId: number;
    projectManagerId: number;
    startDate: Date;
    baseEndDate: Date;
    endDate: Date;
    objectStateId: number;
    shortDescription: string;
    description: string;
    systemVersionId: number;
    contactPersonId: number;
    isDateUnlimited: boolean;
    budget: number;
    hourlyRate: number;
    customerName: string;
    receiverName: string;
    projectWatchers: ProjectWatcher[];
    newProjectSteps: ProjectStep[];
    attachments: AttachmentInfo[];
    constructor(id: number) {
        this.id = id;
    }
}

export class ProjectRow {
    id: number;
    projectId: number;
    numberString: string;
    projectStepName: string;
    projectStepStartDate: Date;
    projectStepEndDate: Date;
    projectStepBudget: number;
    projectStepTimeBudget: number;
    customerId: number;
    customerCode: string;
    customerName: string;
    shortDescription: string;
}

export class ProjectWatcher {
    id: number;
    employeeId: number;
    projectId: number;
    projectWatcherName: string;
    employee: any;
}

export class HistoryLog {
    oldValue: string;
    newValue: string;
    objectName: string;
    updatedBy: string;
    updatedDate: Date;
}

export class ProjectStepRow {
    id: number;
    name: string;
    startDate: Date;
    endDate: Date;
    payerName: string;
    timeSpent: string;
    invoiceTime: string;
    objectStateName: string;
    isPublic: boolean;
}

export class ProjectStep {
    id: number;
    projectId: number;
    name: string;
    description: string;
    budget: number;
    timeBudget: number;
    objectTypeId: number;
    customerId: number;
    objectStateId: number;
    invoiceNumber: string;
    payerId: number;
    areaPathId: number;
    isPublic: boolean;
    customerVstsEpicId: number;
    startDate: Date;
    endDate: Date;

    customerName: string;
    payerName: string;
    oldObjectState: string;
    objectStateName: string;
}

export class ProjectStepIssue {
    name: string;
    startDate: Date;
    timeSpent: number;
    invoiceTime: number;
    assigneeName: string;
    elementAssignee: string;
    objectStateName: string;
}

export class ProjectStepWorklog {
    issueName: string;
    number: string;
    employee: string;
    workDate: Date;
    timeSpent: number;
    invoiceTime: number;
    description: string;
}

export enum ProjectType {
    Project,
    Order,
    Service,
    Consultations
}